<ng-template #actions>

    <div class="loyalty-hero-header__row">
        <div class="loyalty-hero-header__col">
            <shared-btn class="loyalty-hero-header__btn -for-create-account"
                (onClick)="handleCreateAccountClick($event)" [size]="btnSize" [inverted]="true" [feel]="btnAccountFeel">
                Create Account
            </shared-btn>
        </div>
        <div class="loyalty-hero-header__col">
            <shared-btn class="loyalty-hero-header__btn -for-create-account" (onClick)="handleSignInClick($event)"
                [size]="btnSize" [inverted]="true" [feel]="btnSignInFeel">Sign In</shared-btn>
        </div>
    </div>

</ng-template>

<shared-hero-header [preTitle]="preHead" [postTitle]="actions" [marginBottom]="marginBottom" [type]="headerType"
    [center]="center" [preHeaderCenter]="center">
    <div class="loyalty-hero-header__text-line" *ngFor="let textLine of text">{{textLine}}</div>
</shared-hero-header>